import { Query, Mutation } from './types';
import axios, { CancelToken } from 'axios';
import qs from 'qs';

export const getCanceler = axios.CancelToken.source;

export interface RequestOptions {
  cancelToken?: CancelToken;
  authToken?: string;
}

export const makeRequest = <T>(
  r: Query<T> | Mutation<T>,
  options: RequestOptions = {}
): Promise<T> =>
  axios
    .request({
      url: r.url + stringifyParams(r.params),
      method: 'method' in r ? r.method : 'GET',
      data: 'data' in r ? JSON.stringify(r.data) : undefined,
      headers: {
        'content-type': 'data' in r ? 'application/json' : undefined,
        authorization: options.authToken
          ? `Bearer ${options.authToken}`
          : undefined
      },
      cancelToken: options.cancelToken
    })
    .then(res => res.data)
    .catch(error => {
      if (axios.isCancel(error)) {
        const err = { canceled: true };
        throw err;
      } else {
        throw error;
      }
    });

export const stringifyParams = (params: any) => {
  const str = qs.stringify(params, { sort: (a, b) => a.localeCompare(b) });
  return str ? `?${str}` : '';
};

export const paginationParams = (
  page: number,
  perPage: number,
  filters: any
) => ({
  limit: perPage,
  offset: (page - 1) * perPage,
  ...filters
});
